export default __webpack_public_path__ + "static/media/4.996eb6d8.png";